import { apiOps } from 'src/api/defs/apiOps'
import { HigherApiClient } from 'src/api/client/ApiClient'
import { UnlockTokenInfo } from 'src/api/defs/UnlockTokenInfo.type'
import { getGeolocation } from 'src/geo/locationService'
import { Coordinates } from 'src/api/defs/Coordinates.type'

const ops = apiOps.AdminCommonUnlockToken

type UnlockTokenFilter = {
    email: string
    token: string
}

type UnlockWarehouseFilter = {
    id: number
    email: string
    token: string
}

type UnlockWarehouseQrFilter = {
    xNonce: string
    token: string
    coordinates?: Coordinates
}

type UnlockBoxFilter = UnlockWarehouseFilter

export class AdminCommonUnlockTokenApi {
    constructor(private api: HigherApiClient) {}
    unlockTokens = async ({
        email,
        token
    }: UnlockTokenFilter): Promise<UnlockTokenInfo> =>
        this.api.do<UnlockTokenInfo>(ops.unlockTokensAuth, {
            queryParams: { email, token }
        })

    unlockWarehouseQr = async ({
        xNonce,
        token,
        coordinates
    }: UnlockWarehouseQrFilter): Promise<number> =>
        this.api.do<number>(ops.unlockWarehouseQr, {
            headers: { 'X-Nonce': xNonce },
            pathParams: { token },
            data: coordinates
        })

    unlockBox = async (
        { id, email, token }: UnlockBoxFilter,
        useCache = false
    ): Promise<number> =>
        this.api.do<number>(ops.unlockBox, {
            pathParams: { id, email, token },
            data: await getGeolocation(useCache)
        })

    unlockWarehouse = async (
        { id, email, token }: UnlockWarehouseFilter,
        useCache = false
    ): Promise<number> =>
        this.api.do<number>(ops.unlockWarehouse, {
            pathParams: { id, email, token },
            data: await getGeolocation(useCache)
        })
}
